import { Component, Input, ViewEncapsulation } from '@angular/core';
import { NgIf } from '@angular/common';

import { pageTransitions } from '../../../../shared/animations/page-transitions';
import { CoilSegment } from '../../../models/coil-segment';

import { BendingComponent } from './bending.component';
import { ErichsenComponent } from './erichsen.component';
import { NotchComponent } from './notch.component';
import { HardnessComponent } from './hardness.component';
import { BakeHardeningComponent } from './bake-hardening.component';
import { AnisotropyComponent } from './anisotropy.component';
import { TensileComponent } from './tensile.component';

@Component({
	selector: 'copo-mechanical-characteristics',
	templateUrl: './mechanical-characteristics.component.html',
	styleUrl: '../aqdb-batch-card.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		TensileComponent,
		AnisotropyComponent,
		BakeHardeningComponent,
		HardnessComponent,
		NotchComponent,
		ErichsenComponent,
		BendingComponent
	]
})
export class MechanicalCharacteristicsComponent {
	@Input() isValidServiceAvailable = false;
	@Input() segment?: CoilSegment;
}
